@if (missing()) {
  <section class="page-intro">
    <p class="kicker">{{ lang.t('trTicket') }}</p>
    <h1>{{ lang.t('trMissing') }}</h1>
    <p class="lede">{{ lang.t('trMissingP') }}</p>
    <a class="btn primary" routerLink="/markets">{{ lang.t('trBack') }}</a>
  </section>
} @else if (quote(); as quote) {
  <section class="trade-head">
    <div>
      <p class="kicker">{{ lang.t('one' + quote.assetClass) }}</p>
      <h1>{{ quote.symbol }} <span>{{ quote.name }}</span></h1>
      <p class="blurb">{{ quote.blurb }}</p>
    </div>
    <div class="trade-last">
      <strong>{{ price(quote.price, quote.precision) }}</strong>
      <em [class.up]="quote.changePct >= 0" [class.down]="quote.changePct < 0">
        {{ price(quote.change, quote.precision) }} · {{ pct(quote.changePct) }}
      </em>
    </div>
  </section>

  <div class="stat-row">
    <div><span>{{ lang.t('trOpen') }}</span><strong>{{ price(quote.open, quote.precision) }}</strong></div>
    <div><span>{{ lang.t('trHigh') }}</span><strong>{{ price(quote.high, quote.precision) }}</strong></div>
    <div><span>{{ lang.t('trLow') }}</span><strong>{{ price(quote.low, quote.precision) }}</strong></div>
    <div><span>{{ lang.t('trVolume') }}</span><strong>{{ compact(quote.volume) }}</strong></div>
  </div>

  <div class="trade-layout">
    <div class="panel chart-panel">
      <div class="panel-label">
        <span>{{ lang.t('trSession') }}</span>
        <span>{{ lang.t('trCandles') }}</span>
      </div>
      <app-candle-chart [candles]="detail()!.candles" [precision]="quote.precision" />
    </div>

    <form class="panel ticket" (ngSubmit)="submit()">
      <div class="side-switch" role="group" [attr.aria-label]="lang.t('trSide')">
        <button type="button" [class.on]="side() === 'BUY'" (click)="side.set('BUY')">{{ lang.t('trBuy') }}</button>
        <button type="button" class="sell" [class.on]="side() === 'SELL'" (click)="side.set('SELL')">{{ lang.t('trSell') }}</button>
      </div>

      <label>
        {{ lang.t('trQty') }}
        <input type="number" min="0" step="any" name="quantity" [ngModel]="quantity()" (ngModelChange)="onQuantity($event)" />
      </label>
      <div class="presets">
        @for (preset of presets(); track preset) {
          <button type="button" (click)="setQuantity(preset)">{{ preset }}</button>
        }
      </div>

      <dl class="ticket-math">
        <div><dt>{{ lang.t('trFill') }}</dt><dd>{{ price(fill(), quote.precision) }}</dd></div>
        <div><dt>{{ lang.t('trNotional') }}</dt><dd>{{ money(notional()) }}</dd></div>
        @if (auth.user(); as user) {
          <div><dt>{{ lang.t('trCash') }}</dt><dd>{{ money(user.cash) }}</dd></div>
        }
      </dl>

      @if (auth.signedIn()) {
        <button class="btn submit" [class.sell]="side() === 'SELL'" type="submit" [disabled]="submitting()">
          {{ submitting() ? lang.t('trSending') : (side() === 'BUY' ? lang.t('trBuy') : lang.t('trSell')) + ' ' + quote.symbol }}
        </button>
        <button type="button" class="text-link watch-btn" (click)="toggleWatch()">
          {{ watched() ? lang.t('trWatchOff') : lang.t('trWatchOn') }}
        </button>
      } @else {
        <a class="btn primary submit" routerLink="/signin" [queryParams]="{ returnUrl: '/trade/' + quote.symbol }">{{ lang.t('trSign') }}</a>
        <p class="fine">{{ lang.t('trNew') }} <a routerLink="/signup">{{ lang.t('trOpenAcc') }}</a>.</p>
      }
      <p class="fine">{{ lang.t('trFine') }}</p>
    </form>
  </div>
} @else {
  <section class="page-intro">
    <p class="kicker">{{ lang.t('trTicket') }}</p>
    <h1>{{ lang.t('trOpening') }}</h1>
  </section>
}
